export enum MeasurementCalculationsItemType {
  READONLY = 'READONLY',
  INPUT = 'INPUT'
}

export interface MeasurementCalculationsItem {
  label: string;
  controlName: string;
  value: string | number | number[];
  type: MeasurementCalculationsItemType;
}

export interface MeasurementCalculationsGroup {
  title: string;
  items: MeasurementCalculationsItem[];
}

export interface MeasurementCalculations {
  id: string;
  title: string;
  img: string;
  groups: MeasurementCalculationsGroup[][];
}
